<template>
    <div class="customImg" :style="{'height': actualImageH + 'px','width': actualImageW + 'px'}">
        <!--<img :src="imgUrl" alt="">-->
        <vueCropper
                ref="cropper"
                :img="option.img"
                :outputSize="option.size"
                :outputType="option.outputType"
                :info="true"
                :full="option.full"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :fixedBox="option.fixedBox"
                :original="option.original"
                :canScale="option.canScale"
                :actualImageH="actualImageH"
                @realTime="realTime"
                @sureImgHandle="sureImgHandle"
        ></vueCropper>
    </div>
</template>

<script>
    import api from '../../../api';
    import VueCropper from '../../../components/common/vue/vue-cropper.vue'

    export default {
        data() {
            return {
                imgBaseUrl: api.common.imgBaseUrl,
                option: {
                    img: '',
                    size: 1,
                    full: false,
                    outputType: 'jpeg',
                    canMove: false,
                    fixedBox: false,
                    original: false,
                    canMoveBox: true,
                    canScale: false
                },
                msg:null
            };
        },
        props: {
            imgUrl: {
                type: String
            }, actualImageH: {
                type:Number
            },
            actualImageW: {
                type:Number
            }
        },
        components: {
            VueCropper
        },
        methods: {
            init(){
                this.$refs.cropper.startCrop();
            },
            realTime(data){
                this.msg = {
                    'width': data.w,
                    'height': data.h,
                    'px': data.px,
                    'py':data.py
                }
            },

            sureImgHandle(){ //确定截图完成
                //根据url请求识图接口
                let url = this.option.img + '?x-oss-process=image/crop,x_' + parseInt(this.msg.px) + ',y_' + parseInt(this.msg.py) + ',w_' + parseInt(this.msg.width) + ',h_' + parseInt(this.msg.height)
                api.imgSearch.detect_url(url)
                    .then(res => {
                        let name;
                        if(!res.detectedBoxes || res.detectedBoxes.length === 0){
                            name = '其他'
                        }else{
                            name = res.detectedBoxes[0].type
                        }
                        this.msg.name = name;
                        this.$emit('surePoint', this.msg);
                    })
            }
        },

        created() {
            this.option.img = this.imgBaseUrl + this.imgUrl
            this.$nextTick(() => {
                this.init();
            })
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .customImg{
        width: 100%;
        height: 100%;
        font-size: 0px;
        margin: 0 auto;
    img{
        width: 100%;
    }
    }
</style>
